/**
 * Compact stress menus for AI quality gates.
 *
 * Mirrors the constructor datasets enough to catch overflow / truncation without
 * depending on the frontend package.
 */
const RESTAURANT = {
    id: 'ai-stress-restaurant',
    name: 'Atelier North',
    tagline: 'Seasonal cooking by the harbour',
    currency: 'USD',
    locale: 'en-US',
    timezone: 'America/New_York',
    address: '14 Harbour Walk',
    phone: '+1 555 0100',
    brand: {},
};
function item(id, name, price, position, opts) {
    return {
        id,
        name,
        description: opts?.description,
        price,
        image: opts?.image === false ? undefined : `https://cdn.menuvera.test/items/${id}.jpg`,
        tags: [],
        allergens: [],
        featured: position === 0,
        available: true,
        position,
    };
}
function category(id, name, items, position, image) {
    return {
        id,
        name,
        position,
        image: image ? `https://cdn.menuvera.test/categories/${id}.jpg` : undefined,
        items,
    };
}
function build(label, categories) {
    return {
        id: `ai-stress-${label}`,
        title: 'Dinner',
        subtitle: 'From 17:30',
        footnote: 'A discretionary service charge may apply.',
        categories,
        restaurant: RESTAURANT,
    };
}
export const AI_STRESS_MENUS = {
    sparse: build('sparse', [
        category('starters', 'To Begin', [
            item('s1', 'Charred Octopus', 1800, 0, { description: 'Potato, paprika oil.' }),
            item('s2', 'Burrata', 1600, 1, { description: 'Heirloom tomato, basil.' }),
            item('s3', 'Beetroot Tartare', 1400, 2),
        ], 0, true),
        category('mains', 'Mains', [
            item('m1', 'Duck Confit', 3200, 0, { description: 'White beans, garlic crumb.' }),
            item('m2', 'Sea Bream', 2800, 1),
            item('m3', 'Cauliflower Steak', 2200, 2, { description: 'Brown butter, hazelnut.' }),
            item('m4', 'Ribeye', 4600, 3),
        ], 1),
        category('desserts', 'Sweet', [item('d1', 'Chocolate Pot', 1200, 0), item('d2', 'Citrus Sorbet', 900, 1)], 2),
    ]),
    typical: build('typical', [
        category('snacks', 'Snacks', Array.from({ length: 6 }, (_, i) => item(`sn${i}`, `Snack ${i + 1}`, 900 + i * 50, i, {
            description: 'House pickle, herb salt.',
        })), 0, true),
        category('starters', 'Starters', Array.from({ length: 8 }, (_, i) => item(`st${i}`, `Starter ${i + 1}`, 1400 + i * 80, i, {
            description: 'Seasonal garnish, olive oil.',
        })), 1),
        category('mains', 'From the Fire', Array.from({ length: 11 }, (_, i) => item(`mn${i}`, `Main ${i + 1}`, 2400 + i * 100, i, {
            description: i % 3 === 0 ? undefined : 'Slow cooked, market vegetables.',
        })), 2, true),
        category('sides', 'Sides', Array.from({ length: 5 }, (_, i) => item(`sd${i}`, `Side ${i + 1}`, 700 + i * 40, i)), 3),
        category('desserts', 'Desserts', Array.from({ length: 6 }, (_, i) => item(`ds${i}`, `Dessert ${i + 1}`, 1100 + i * 60, i, {
            description: 'Pastry cream, citrus.',
        })), 4),
    ]),
    noPhotos: build('noPhotos', [
        category('starters', 'Starters', Array.from({ length: 7 }, (_, i) => item(`np-s${i}`, `Starter ${i + 1}`, 1300, i, {
            description: 'Clean flavours, sharp acid.',
            image: false,
        })), 0),
        category('mains', 'Mains', Array.from({ length: 12 }, (_, i) => item(`np-m${i}`, `Main ${i + 1}`, 2600, i, {
            description: 'Market fish or farm meat.',
            image: false,
        })), 1),
        category('desserts', 'Desserts', Array.from({ length: 5 }, (_, i) => item(`np-d${i}`, `Dessert ${i + 1}`, 1000, i, { image: false })), 2),
        category('drinks', 'Drinks', Array.from({ length: 16 }, (_, i) => item(`np-dr${i}`, `Drink ${i + 1}`, 800, i, { image: false })), 3),
    ]),
};
//# sourceMappingURL=stress-menus.js.map